/**
 * 사용자 프로필(온보딩을 마쳤는지 등)을 읽는다. 기기에 남은 것이 있으면 그것을 쓴다.
 *
 * 예전에는 앱을 열 때마다 서버에 물어서, 그 왕복(로그인 토큰 갱신까지 겹치면 더 길다)
 * 동안 '북러닝 LOADING' 화면이 떠 있었다. 프로필에서 앱이 쓰는 값은 온보딩 여부뿐이고
 * 거의 바뀌지 않으므로, 기기 사본으로 바로 열고 서버 값은 뒤에서 확인한다 (hooks/useAuth).
 * Firestore 의 기기 저장(persistentLocalCache)이 켜져 있어야 사본이 있다 (firebase/config).
 *
 * @param {() => Promise<{exists: () => boolean, data: () => object}>} fromCache 기기 사본 (없으면 던진다)
 * @param {() => Promise<{exists: () => boolean, data: () => object}>} fromServer
 * @returns {Promise<{ profile: object|null, fromCache: boolean }>}
 */
export const loadProfile = async (fromCache, fromServer) => {
  try {
    const cached = await fromCache();
    if (cached.exists()) return { profile: cached.data(), fromCache: true };
  } catch { /* 기기에 없으면 서버에서 */ }
  const snap = await fromServer();
  return { profile: snap.exists() ? snap.data() : null, fromCache: false };
};
